import React, { useState } from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { FileDown, Loader2, Plug } from "lucide-react";
import { apiClient } from "@/lib/apiClient";
import { toast } from "sonner";

export const IntegrationSpecCard = () => {
  const [downloading, setDownloading] = useState(false);

  const download = async () => {
    setDownloading(true);
    try {
      const res = await apiClient.get("/admin/integration-spec", { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = "erp_integration_spec.md";
      a.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Download fehlgeschlagen");
    } finally {
      setDownloading(false);
    }
  };

  return (
    <Card className="p-6" data-testid="integration-spec-card">
      <div className="flex items-start gap-3">
        <div className="h-10 w-10 rounded-lg bg-slate-100 text-slate-700 flex items-center justify-center shrink-0">
          <Plug className="h-5 w-5" />
        </div>
        <div className="flex-1">
          <h3 className="text-base font-semibold text-slate-900">Integrations-Spezifikation für Dritt-Apps</h3>
          <p className="mt-1 text-sm text-slate-500">
            Übergabefertige Anleitung, damit externe Systeme (z.B. Kunden-Apps) ihre Rechnungen
            automatisch ins ERP senden: Endpoints, Payloads, API-Key-Auth, Webhooks
            (invoice.paid mit Retry), QR-Referenz-Regeln und Onboarding-Checkliste.
          </p>
          <ul className="mt-3 text-xs text-slate-500 space-y-1 list-disc pl-4">
            <li>Idempotenter Rechnungs-Upsert über <code>external_id</code></li>
            <li>Automatischer Bankabgleich via 27-stelliger QR-Referenz</li>
            <li>Zahlungs-Webhooks zurück an die App (inkl. Teilzahlungen)</li>
            <li><code>type: "rent"</code> → Verbuchung auf 3410 Mietertrag</li>
          </ul>
          <Button
            size="sm"
            className="mt-4"
            onClick={download}
            disabled={downloading}
            data-testid="integration-spec-download-button"
          >
            {downloading ? <Loader2 className="h-4 w-4 mr-1.5 animate-spin" /> : <FileDown className="h-4 w-4 mr-1.5" />}
            Spezifikation herunterladen (.md)
          </Button>
        </div>
      </div>
    </Card>
  );
};

export default IntegrationSpecCard;
